import React from 'react';
import 'styles/Footer.scss';
import axelLogo from '../../../assets/axel-logo.svg'
import facebookIcon from '../../../assets/facebook.svg'
import instaIcon from '../../../assets/instagram.svg'
import linkedinIcon from '../../../assets/linkedin.svg'

const Footer = () => {
    return (
        <footer className="footer py-10 mt-auto pb-20 bg-black">
            <div className='container mx-auto'>
                <div className='flex justify-between py-11 border-b border-zinc-800'>
                    <img src={axelLogo} alt="Axel logo" />
                    <div className='flex'>
                        <button className='border px-5 py-3 rounded-full border-white bg-transparent text-white hover:border-white hover:bg-white hover:text-black transition-all'>My Account</button>
                        <button className='border px-5 py-3 bg-size-200 hover:bg-[length:150%_150%] transition-all duration-500 rounded-full bg-gradient-to-r from-[#97365c] to-[#38089e] text-white bg-[length:200px_200px] hover:bg-right-bottom border-none ml-5'>Get access today</button>
                    </div>
                </div>
                <div className='flex py-7 justify-between'>
                    <ul className='text-white'>
                        <li className='inline-block text-sm hover:text-slate-300 transition-colors'>Terms & Conditions</li>
                        <li className='ml-12 text-sm inline-block hover:text-slate-300 transition-colors'>Privacy Policy</li>
                        <li className='ml-12 text-sm inline-block hover:text-slate-300 transition-colors'>Contact Us</li>
                    </ul>
                    <ul>
                        <li className='inline-block'><img src={facebookIcon} className='size-4' alt="Facebook" /></li>
                        <li className='inline-block ml-3'><img src={instaIcon} className='size-4' alt="Instagram" /></li>
                        <li className='inline-block ml-3'><img src={linkedinIcon} className='size-4' alt="LinkedIn" /></li>
                    </ul>
                </div>
                <p className='text-xs text-white'>&copy; Copyright 2024 Axel Specialty Insurance, LLC. All Rights Reserved. 2280 East Bidwell St, Suite 104 Folsom, CA 95630, USA. CA License #0000222 A Integrated Underwriters Company. Website by Ocu Agency.</p>
            </div>
            {/* <p className='text-center'>&copy; 2024 FMP. All rights reserved.</p> */}
        </footer>
    );
}

export default Footer;
